import {
  Autocomplete,
  GoogleMap,
  Marker,
  useLoadScript
} from '@react-google-maps/api'
import { Form, notification } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledInput = styled.input`
  box-sizing: border-box;
  border: 1px solid transparent;
  width: 400px;
  height: 40px;
  padding: 0 12px;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  font-size: 1.4rem;
  outline: none;
  text-overflow: ellipses;
  position: absolute;
  left: calc(50% - 200px);
  top: 8px;
`
const StyledTitle = styled.div`
  font-weight: 700;
  font-size: 1.4rem;
  margin-bottom: 8px;
`
export interface IPos {
  lat: number
  lng: number
}
export interface IMarker {
  id: string
  pos: IPos
}

interface IProps {
  title?: string
  lat?: number
  lng?: number
  markets?: Array<IMarker>
  zoom?: number
  onChange?: (value: IPos) => void
}

const GMap = (props: IProps) => {
  const { title, lat, lng, onChange, zoom } = props
  const { t } = useTranslation()
  const refAutocomplete = useRef<any>(null)
  const [form] = Form.useForm()
  const onLoad = (autocomplete: any) => {
    refAutocomplete.current = autocomplete
  }
  const [center, setCenter] = useState({
    lat: 10.800431502026832,
    lng: 106.63608135732
  })
  useEffect(() => {
    if (lat && lng) {
      setCenter({ lat, lng })
      setMarkersMap([
        {
          id: '',
          pos: {
            lat,
            lng
          }
        } as IMarker
      ])
    }
  }, [lat, lng])
  const [markersMap, setMarkersMap] = useState<IMarker[]>([])
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: 'AIzaSyCyEwnKcLGo6ImvRFlZ0gCC-JqDe606oew',
    libraries: ['places']
  })
  const handleClickMap = (e: any) => {
    setMarkersMap([
      {
        id: e.placeId || 'clinicPosition',
        pos: e.latLng.toJSON()
      }
    ])
    form.setFieldsValue({
      latitude: e.latLng.toJSON().lat,
      longitude: e.latLng.toJSON().lng
    })
    if (onChange)
      onChange({ lat: e.latLng.toJSON().lat, lng: e.latLng.toJSON().lng })
  }

  const onPlaceChanged = () => {
    if (refAutocomplete !== null) {
      const { geometry, place_id = '' } = refAutocomplete.current?.getPlace()
      if (geometry) {
        setMarkersMap([
          {
            id: place_id,
            pos: {
              lat: geometry.location.lat(),
              lng: geometry.location.lng()
            }
          }
        ])
        setCenter({
          lat: geometry.location.lat(),
          lng: geometry.location.lng()
        })
        form.setFieldsValue({
          latitude: geometry.location.lat(),
          longitude: geometry.location.lng()
        })
      } else {
        notification.error({
          message: 'Không tìm thấy vị trí. Vui lòng nhập lại!'
        })
      }
    } else {
      notification.error({
        message: 'Không tìm thấy vị trí. Vui lòng nhập lại!'
      })
    }
  }
  return (
    <>
      {!!title && <StyledTitle>{t(title || '')}</StyledTitle>}

      {isLoaded && (
        <GoogleMap
          center={center}
          zoom={zoom || 12}
          onClick={(e) => handleClickMap(e)}
          mapContainerStyle={{
            height: '70vh',
            width: '100%'
          }}>
          <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
            <StyledInput type="text" placeholder={t('input-location')} />
          </Autocomplete>
          {markersMap.map((place) => (
            <Marker
              key={place.id}
              position={place.pos}
              icon={'images/ic-location.svg'}
            />
          ))}
        </GoogleMap>
      )}
    </>
  )
}

export default GMap
